import {DefaultTheme} from 'styled-components';

import {Themes as ThemesTwentyDE, Messages as MessagesTwentyDE} from '@brands/twentyDE';
import {Themes as ThemesTwentyFR, Messages as MessagesTwentyFR} from '@brands/twentyFR';
import {Themes as ThemesLeMatin, Messages as MessagesLeMatin} from '@brands/lematin';

export const getThemes = (): {[key: string]: DefaultTheme} => {
    if (process.env.brand === 'twentyFR') {
        return ThemesTwentyFR;
    }

    if (process.env.brand === 'lematin') {
        return ThemesLeMatin;
    }

    return ThemesTwentyDE;
};

export const getMessages = (): {[key: string]: string} => {
    if (process.env.brand === 'twentyFR') {
        return MessagesTwentyFR;
    }

    if (process.env.brand === 'lematin') {
        return MessagesLeMatin;
    }

    return MessagesTwentyDE;
};
